<!--权限个人模板-->
<template>
    <div v-if="isMounted">
        <div class="another_right m-portlet" >
            <div class="m-portlet__body" v-loading="$parentInfo.anotherAuthorityList.rightLoading">
                <div class="m-portlet__body" v-if="checkedEmployee_id!==''" >
                    <el-row>
                        <el-col :span="16">
                            <b>{{$parentInfo.anotherAuthorityList.checkedEmployee.name}}</b>
                        </el-col>
                        <el-col :span="7">
                            <el-popover placement="right" width="280" trigger="click">
                                <el-row :gutter="24">
                                    <el-col :span="16">
                                        <el-select v-model="addTemplate" clearable placeholder="请选择权限模板"
                                                   filterable remote multiple
                                                   :remote-method="handleSearchTemplate">
                                            <el-option
                                                    v-for="item in $parentInfo.anotherAuthorityList.searchTemplates"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="8">
                                        <div align="right">
                                            <el-button @click="handleAddTemplate()"
                                                       :loading="$parentInfo.anotherAuthorityList.button_loading">提交
                                            </el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-button size="mini" slot="reference">员工中添加模板</el-button>
                            </el-popover>
                        </el-col>
                    </el-row>
                </div>
                <vue-scroll :ops="$ops">
                    <div  :style="{'height':(clientHeight-280)+'px'}">
                        <el-row>
                            <el-col :span="9">
                                <el-select v-model="section_id" clearable placeholder="请选择校区"
                                           :loading="$parentInfo.search_loading"
                                           @change="handleTemplateIndex" style="width: 120px">
                                    <el-option
                                            v-for="item in $parentInfo.sections"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <el-select v-model="template_id" clearable placeholder="请选择模板" filterable remote
                                           :remote-method="handleSearchTemplate"
                                           @change="handleTemplateIndex"
                                           :loading="$parentInfo.search_loading">
                                    <el-option
                                            v-for="item in $parentInfo.anotherAuthorityList.searchTemplates"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>名称</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item,index) in $parentInfo.anotherAuthorityList.powerTemplates" :key="index">
                                <td>{{item.name}}</td>
                                <td>
                                    <el-button size="mini"
                                               @click="handleToPowerTemplate(item.id)">查看权限
                                    </el-button>
                                    <el-button type="danger" icon="el-icon-delete" size="mini" circle
                                               v-if="checkedEmployee_id!==''"
                                               @click="handleDestroyPowerTemplate(item.id)"></el-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </vue-scroll>
            </div>
        </div>
        <div class="another_left m-portlet">
            <vue-scroll :ops="$ops">
                <div class="m-portlet__body"   v-loading="$parentInfo.anotherAuthorityList.leftLoading">
                    <div :style="{'height':(clientHeight-280)+'px'}">
                        <div style="display: flex;justify-content: space-between">
                            <div>
                                <el-select v-model="employee"
                                           placeholder="请选择员工"
                                           clearable
                                           filterable
                                           remote
                                           :remote-method="handleSearchEmployee"
                                           @change="handleIndexEmployee(1,10)"
                                           :loading="$parentInfo.search_loading">
                                    <el-option
                                            v-for="item in $parentInfo.anotherAuthorityList.searchEmployees"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div>
                                <el-button @click="handelStoreEmployee">新增员工</el-button>
                            </div>
                        </div>
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>姓名</th>
                                <th>账号</th>
                                <th>角色</th>
                                <th>状态</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item,index) in $parentInfo.anotherAuthorityList.employees" :key="index">
                                <td>{{item.name}}</td>
                                <td v-if="item.account_number==='发送注册'">
                                    <el-button @click="handleSendRegister(item.id)">{{item.account_number}}</el-button>
                                </td>
                                <td v-else>{{item.account_number}}</td>
                                <td>
                                    <span v-for="identity in item.identity">
                                         <el-button size="mini" @click="handleJump(identity)"
                                                    style="background-color: hsla(220,4%,58%,.1);border-color: hsla(220,4%,58%,.2);color: #909399;margin: 0 2px">
                                           {{identity}}
                                        </el-button>
                                    </span>
                                </td>
                                <td v-if="item.status">在职</td>
                                <td v-else>离职</td>
                                <td>
                                    <el-button @click="handleUpdateTemplate(item.id)">查看权限</el-button>
                                    <el-button v-if="index===clickIndex" @click="handleCancel()" type="danger"
                                               size="mini">
                                        关闭
                                    </el-button>
                                    <el-button v-else @click="handleToTemplate(item.id,index)">展开</el-button>
                                    <el-button @click="handleUpdateEmployee(item)">修改</el-button>
                                    <el-button @click="handleUpdateAccount(item.id)">修改账号</el-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!--分页-->
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="$parentInfo.anotherAuthorityList.total">
                            </el-pagination>
                        </div>
                    </div>

                </div>
            </vue-scroll>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AnotherAuthorityList",
        data() {
            return {
                isMounted: false,
                employee_id: '',
                checkedEmployee_id: '',
                employee: '',
                currentPage: 1,
                currentPageSize: 10,
                clickIndex: '',
                section_id: '',
                addTemplate: [],
                template_id: '',
            }
        },
        mounted() {
            this.isMounted = true;
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleIndexEmployee(1, 10);
            this.handleSearchEmployee("");
            this.handleTemplateIndex();
            this.handleSearchTemplate("");
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            powers(){
                return this.$store.state.config.powers;
            }
        },
        methods: {
            //显示选择的模板列表
            handleToTemplate(id, index) {
                this.addTemplate = [];
                this.section_id = '';
                this.template_id = '';
                this.clickIndex = index;
                this.checkedEmployee_id = id;
                this.$parentInfo.anotherAuthorityList.checkKey = true;
                this.handleSearchEmployee('');
                this.handleEmployeeShow();
                this.handleTemplateIndex();
                this.$parentInfo.anotherAuthorityList.rightLoading = true;
            },
            //恢复默认模板列表
            handleCancel() {
                this.addTemplate = [];
                this.section_id = '';
                this.template_id = '';
                this.clickIndex = '';
                this.checkedEmployee_id = '';
                this.$parentInfo.anotherAuthorityList.checkKey = false;
                this.$parentInfo.anotherAuthorityList.rightLoading = true;
                this.$nextTick(() => {
                    this.handleTemplateIndex();
                })
            },
            //筛选员工
            handleSearchEmployee(query) {
                this.$parentInfo.search_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'search_employeeAndTemplate', {
                    'searchKey': query,
                    'section_id': this.section_id,
                    'type': 'searchEmployee',
                });
            },
            //筛选模板
            handleSearchTemplate(query) {
                this.$parentInfo.search_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'search_employeeAndTemplate', {
                    'searchKey': query,
                    'section_id': this.section_id,
                    'type': 'searchTemplate',
                });
            },
            //筛选模板
            changeSection() {
                this.handleTemplateIndex();
            },
            //展示员工列表
            handleIndexEmployee(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.$parentInfo.path, 'get_employeePowerTemplateList', {
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                    'employee_id': this.employee,
                });
            },
            //员工中模板列表
            handleTemplateIndex() {
                if (this.checkedEmployee_id !== '') {
                    this.$wApi.send(this.$parentInfo.path, 'get_templateIndex', {
                        'employee_id': this.checkedEmployee_id,
                        'section_id': this.section_id,
                        'template_id': this.template_id
                    });
                } else {
                    this.$wApi.send(this.$parentInfo.path, 'get_powerTemplateList', {
                        'section_id': this.section_id,
                        'template_id': this.template_id
                    });
                }

            },
            //展示选中的员工
            handleEmployeeShow() {
                this.$wApi.send(this.$parentInfo.path, 'get_employeePowerTemplate', {
                    'id': this.checkedEmployee_id,
                });
            },
            //添加模板进员工
            handleAddTemplate() {
                this.$parentInfo.anotherAuthorityList.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'give_template_to_employee', {
                    'employee_id': this.checkedEmployee_id,
                    'addTemplate': this.addTemplate,
                });
            },
            //删除员工中的模板
            handleDestroyPowerTemplate(id) {
                this.$parentInfo.anotherAuthorityList.index = id;
                this.$confirm('是否删除员工所在模板?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'delete_employee_from_powerTemplate', {
                        'employee_id': this.checkedEmployee_id,
                        'id': id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //查看模板权限
            handleToPowerTemplate(id) {
                this.$Win.openModal('Dialog_UpdatePowerTemplate', 1024, 900, '查看权限模板', {
                    'id': id,
                });
            },
            //修改员工权限
            handleUpdateTemplate(id) {
                this.$Win.openModal('Dialog_TemplateUpdateEmployeePower', 1024, 900, '查看员工权限', {
                    'id': id,
                });
            },

            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexEmployee(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexEmployee(this.currentPage, this.currentPageSize)
            },
            handleUpdateEmployee(employee){
                this.$Win.openModal('Dialog_UpdateEmployee',  750, 700, '修改员工信息', {
                    'employee': employee,
                });
            },
            handleSendRegister(employee_id){
                this.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'set_sms_to_register', {
                    'employee_id': employee_id,

                });
            },
            handleJump(type){
                if(type=='老师'){
                    this.$store.dispatch('addView', {
                        'title': '教师列表',
                        'path': '/teacher/list',
                        'closable': true
                    });
                    this.router.push({path: '/teacher/list'})
                }else if(type=='班主任'){
                    return 0;
                }
            },
            handelStoreEmployee(){
                this.$Win.openModal('Dialog_StoreEmployee',  650, 700, '新增用户', {});
            },
            handleCancelUser(employee_id,disabled){
                this.$confirm('此操作将注销该账户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'cancel_user', {
                        'employee_id': employee_id,
                        'disabled': disabled,
                    });
                }).catch(() => {
                    this.$parentInfo.authorityList.button_loading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleUpdateAccount(employee_id){
                this.$Win.openModal('Dialog_UpdateAccount', 400, 800, '修改账号',{'employee_id':employee_id});
            }
        }
    }
</script>

<style scoped>
    .another_left {
        margin-right: 405px;
    }

    .another_right {
        float: right;
        width: 400px;
    }
</style>
